import * as React from "react";

import type { LinkRouteDefaults } from "@stadium/shared/src/components/link-with-lang";

import CE10, { CE10Props } from "@stadium/shared/src/components/plasmic/CE10";
import CE11, { CE11Props } from "@stadium/shared/src/components/plasmic/CE11";
import CE13, { CE13Props } from "@stadium/shared/src/components/plasmic/CE13";

import {
  CatalogEntriesVariant,
  CE_10,
  CE_11,
  CE_13,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export interface CE11CatalogEntriesProps {
  eyebrowText?: CE11Props["eyebrowText"];
  mainHeading?: CE11Props["mainHeading"];
  highlightedWord1?: CE11Props["highlightedWord1"];
  highlightedWord2?: CE11Props["highlightedWord2"];
  highlightedWord3?: CE11Props["highlightedWord3"];
  subHeading?: CE11Props["subHeading"];
  description?: CE11Props["description"];
  ctaText?: CE11Props["ctaText"];
  ctaLinkType?: CE11Props["ctaLinkType"];
  ctaOtherUrl?: CE11Props["ctaOtherUrl"];
  ctaCategorySlug?: CE11Props["ctaCategorySlug"];
  gridItem1?: CE11Props["gridItem1"];
  gridItem2?: CE11Props["gridItem2"];
  gridItem3?: CE11Props["gridItem3"];
  gridItem4?: CE11Props["gridItem4"];
  gridItem5?: CE11Props["gridItem5"];
  gridItem6?: CE11Props["gridItem6"];
  gridItem7?: CE11Props["gridItem7"];
  gridItem8?: CE11Props["gridItem8"];
  gridItem9?: CE11Props["gridItem9"];
}

export interface CE10CatalogEntriesProps {
  contentHeading?: CE10Props["contentHeading"];
  contentDescription?: CE10Props["contentDescription"];
  cards?: CE10Props["cards"];
  backgroundColor?: CE10Props["backgroundColor"];
}

export interface CE13CatalogEntriesProps {
  heading?: CE13Props["heading"];
  catalogs?: CE13Props["catalogs"];
}

export interface StaticCatalogEntriesProps
  extends CE10CatalogEntriesProps,
    CE11CatalogEntriesProps,
    CE13CatalogEntriesProps {
  variant?: CatalogEntriesVariant;
  className?: string;
  linkRouteDefaults?: LinkRouteDefaults;
}

const StaticCatalogEntries: React.FC<Readonly<StaticCatalogEntriesProps>> = (props) => {
  const { variant = CE_11 } = props;

  if (variant === CE_10) {
    const { contentHeading, contentDescription, cards, backgroundColor, className } = props;

    return (
      <CE10
        contentHeading={contentHeading}
        contentDescription={contentDescription}
        cards={cards}
        backgroundColor={backgroundColor}
        className={className}
      />
    );
  }

  if (variant === CE_11) {
    return <CE11 {...props} />;
  }

  if (variant === CE_13) {
    const { heading, catalogs, className, linkRouteDefaults } = props;

    return (
      <CE13
        heading={heading}
        catalogs={catalogs}
        className={className}
        linkRouteDefaults={linkRouteDefaults}
      />
    );
  }

  return null;
};

export default StaticCatalogEntries;
